import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/t_logo.png'
import _imports_1 from '../assets/icon1.png'
import _imports_2 from '../assets/icon4.png'
import _imports_3 from '../assets/icon5.png'


const _withScopeId = n => (_pushScopeId("data-v-7c131ab5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row d-flex justify-content-center mt-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Vue logo",
    src: _imports_0,
    class: "mt-2 text-center",
    style: {"max-width":"300px"}
  })
], -1))
const _hoisted_3 = { class: "row bg-dange text-center justify-content-center" }
const _hoisted_4 = { class: "fs-3" }
const _hoisted_5 = { class: "card card-body text-center shadow" }
const _hoisted_6 = { class: "fs-3" }
const _hoisted_7 = { class: "fs-3" }
const _hoisted_8 = { class: "mt-3" }
const _hoisted_9 = { class: "d-flex flex-row" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"align-self-center\" data-v-7c131ab5><div class=\"text-center\" data-v-7c131ab5><img alt=\"Vue logo\" src=\"" + _imports_1 + "\" class=\"mt-2\" style=\"width:70%;\" data-v-7c131ab5></div><div class=\"text-center\" data-v-7c131ab5><span class=\"h3\" data-v-7c131ab5>健診結果</span></div></div>", 1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "Vue logo",
      src: _imports_2,
      class: "mt-2",
      style: {"width":"50%"}
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "h3" }, "設定")
  ])
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "Vue logo",
      src: _imports_3,
      class: "mt-2",
      style: {"width":"50%"}
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "h5" }, "ログアウト")
  ])
], -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, "お名前：" + _toDisplayString(_ctx.userInfo?.userName) + "　様", 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_vue_qrcode, {
        value: _ctx.userInfo.userId,
        options: _ctx.qrOption,
        class: "qr-code align-self-center"
      }, null, 8, ["value", "options"]),
      _createElementVNode("span", _hoisted_6, _toDisplayString((_ctx.userInfo.userId as string).substring(0, 8)), 1),
      _createElementVNode("span", _hoisted_7, _toDisplayString((_ctx.userInfo.userId as string).substring(8)), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: "p-3 card card-body me-2 shadow flex-item d-flex flex-column justify-content-around",
          style: {"cursor":"pointer"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.move('/exam')))
        }, _hoisted_11),
        _createElementVNode("div", {
          class: "p-3 card card-body ms-2 me-2 shadow flex-item d-flex flex-column justify-content-around",
          style: {"cursor":"pointer"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.move('/settings')))
        }, _hoisted_13),
        _createElementVNode("div", {
          class: "p-3 card card-body ms-2 shadow flex-item d-flex flex-column justify-content-around",
          style: {"cursor":"pointer"},
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.move('/logout')))
        }, _hoisted_15)
      ])
    ])
  ]))
}